module.exports = __webpack_public_path__ + "img/Satellite-Antenna-Graphic.9b38f234.jpg";